import _ from 'lodash'
import Backbone from 'backbone'
import ActualValueFilter from './actual-value-filter'
import PeriodRangeDateFilter from './period-range-date-filter'
import template from './metric-value-filter.hbs'

/* This view encapsulates a metric value filter which is composed of 2 views
 * an actual value filter (which is an extension of a numeric filter with
 * additional metric specific values) and a calendar range view, together these
 * 2 views provide the resources to gather the data for a metric value filter
 */
var MetricValueFilter = Backbone.View.extend({

	//this.data is a MetricValueFilter which is a java POJO

	initialize: function(options) {
		this.options = options
		this.data = this.options.data || {}

		//in addition to the regular number operators, add is-yes, is-no, is-na
		this.actualValueFilter = new ActualValueFilter(options)
		this.periodRangeDateFilter = new PeriodRangeDateFilter(options)
	},

	render: function() {
		this.$el.html(template())
		this.actualValueFilter.setElement(this.$('.actual-value-filter-container')).render()
		this.periodRangeDateFilter.setElement(this.$('.applies-to-container')).render()
		return this
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		let numericTest = this.actualValueFilter.test()
		let dateTest = this.periodRangeDateFilter.test()
		if (_.isNil(numericTest) && _.isNil(dateTest)) {
			return null
		}
		return _.filter([numericTest, dateTest], v => !_.isNil(v))
	},

	/**
	 * Returns the data gather by the filters used in this view
	 */
	gather: function(e) {
		return _.extend(this.data, this.actualValueFilter.gather(), this.periodRangeDateFilter.gather())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.actualValueFilter, this.periodRangeDateFilter], 'remove')
	}

})

export default MetricValueFilter

MetricValueFilter.__filename__ = 'reports/wizard/filter-meta/metric-value-filter.js'
